import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert } from '@mui/material';
import XeroSso from '../XeroSso';
export default function LoggedOut() {
    return (_jsxs("div", { children: [_jsx(Alert, { severity: "success", children: "Logged out successfully" }), _jsx("br", {}), _jsx(XeroSso, { mode: "sign-in" })] }));
}
